module.exports = __webpack_public_path__ + "img/logo_white.fb6fa0d.svg";